<template>
  <div v-if="!userDetails?.premiumGames?.includes('geogrid')" class="wrapper">
    <div id="adngin-adhesive-0"></div>
  </div>
</template>

<script>
  import { activateAdUnit } from '../../utils/ads';
  import { inject } from 'vue';

  export default {
    name: 'MobileAdhesiveAd',
    inject: ['isAdScriptLoaded'],
    watch: {
      isAdScriptLoaded: {
        handler(isLoaded) {
          if (!isLoaded) return;
          if (window.innerWidth > 1024) return;
          activateAdUnit('adhesive');
        },
        immediate: true,
      },
    },
    setup() {
      return {
        userDetails: inject('userDetails'),
      };
    },
  };
</script>

<style scoped>
  @media (min-width: 1024px) {
    .wrapper {
      display: none;
    }
  }
</style>
